module.exports = __webpack_public_path__ + "static/media/pure_bg.6b86c784.jpeg";